import { Injectable } from '@angular/core';
import type { Editor } from 'tinymce';

@Injectable({ providedIn: 'root' })
export class SpEditorService {
    private editorInstance: Editor;

    public setEditor(editor: Editor) {
        this.editorInstance = editor;
    }

    public simulateBlur() {
        if (this.editorInstance) {
            this.editorInstance.fire('blur');
        }
    }
}
